import project1 from '../../assets/project/project1.png';
import project2 from '../../assets/project/project2.png';
import project3 from '../../assets/project/project3.png';
import project4 from '../../assets/project/project4.png';
import project5 from '../../assets/project/project5.png';
import project6 from '../../assets/project/project6.png';
import project7 from '../../assets/project/project7.png';
import project8 from '../../assets/project/project8.png';
import project9 from '../../assets/project/project9.png';
import project10 from '../../assets/project/project10.png';
import project11 from '../../assets/project/project11.png';
import project12 from '../../assets/project/project12.png';
import project13 from '../../assets/project/project13.png';
import project14 from '../../assets/project/project14.jpg';
import project15 from '../../assets/project/project15.png';
import project16 from '../../assets/project/project16.png';
import project17 from '../../assets/project/project17.png';
import project18 from '../../assets/project/project18.png';
import project19 from '../../assets/project/project19.png';
import project20 from '../../assets/project/project20.png';
import project21 from '../../assets/project/project21.svg';
import project22 from '../../assets/project/project22.png';
import project23 from '../../assets/project/project23.png';
import project24 from '../../assets/project/project24.png';
import project25 from '../../assets/project/project25.png';
// 프로젝트 사진 필요

const cards = {
  all: [
    { id: 23, name: 'Weevo', file: project23 },
    { id: 24, name: 'Qrumble (큐럼블)', file: project24 },
    { id: 25, name: 'MAVVE', file: project25 },

    { id: 16, name: '도장깨기', file: project16 },
    { id: 17, name: 'GiftU(기프트유)', file: project17 },
    { id: 18, name: 'SongPin', file: project18 },
    { id: 19, name: '쉐어릿(shareeat/it)', file: project19 },
    { id: 20, name: 'KARMA', file: project20 },
    { id: 21, name: '북우리(BOOKWOORI)', file: project21 },
    { id: 22, name: '북덕(bookduck)', file: project22 },
    { id: 9, name: 'BagEasy', file: project9 },
    { id: 10, name: '시간표 아티스트', file: project10 },
    { id: 11, name: 'E-DAY (이데이)', file: project11 },
    { id: 12, name: '대행사', file: project12 },
    { id: 13, name: `Let's-JUPJUP`, file: project13 },
    { id: 14, name: 'SweetMe', file: project14 },
    { id: 15, name: '페이퍼즈(PAPERS)', file: project15 },
    { id: 5, name: 'Caker', file: project5 },
    { id: 6, name: '梨상청', file: project6 },
    { id: 7, name: '라꾸라꾸', file: project7 },
    { id: 8, name: 'STEADY DAY', file: project8 },
    { id: 1, name: '맛집전공', file: project1 },
    { id: 2, name: 'EWHA CODIC', file: project2 },
    { id: 3, name: 'Switme', file: project3 },
    { id: 4, name: 'See Me', file: project4 },
  ],
  first: [
    { id: 1, name: '맛집전공', file: project1 },
    { id: 2, name: 'EWHA CODIC', file: project2 },
    { id: 3, name: 'Switme', file: project3 },
    { id: 4, name: 'See Me', file: project4 },
  ],
  second: [
    { id: 5, name: 'Caker', file: project5 },
    { id: 6, name: '梨상청', file: project6 },
    { id: 7, name: '라꾸라꾸', file: project7 },
    { id: 8, name: 'STEADY DAY', file: project8 },
  ],
  third: [
    { id: 9, name: 'BagEasy', file: project9 },
    { id: 10, name: '시간표 아티스트', file: project10 },
    { id: 11, name: 'E-DAY (이데이)', file: project11 },
    { id: 12, name: '대행사', file: project12 },
    { id: 13, name: `Let's-JUPJUP`, file: project13 },
    { id: 14, name: 'SweetMe', file: project14 },
    { id: 15, name: '페이퍼즈(PAPERS)', file: project15 },
  ],
  fourth: [
    { id: 16, name: '도장깨기', file: project16 },
    { id: 17, name: 'GiftU(기프트유)', file: project17 },
    { id: 18, name: 'SongPin', file: project18 },
    { id: 19, name: '쉐어릿(shareeat/it)', file: project19 },
    { id: 20, name: 'KARMA', file: project20 },
    { id: 21, name: '북우리(BOOKWOORI)', file: project21 },
    { id: 22, name: '북덕(bookduck)', file: project22 },
  ],
  fifth: [ 
    { id: 23, name: 'Weevo', file: project23 },
    { id: 24, name: 'Qrumble (큐럼블)', file: project24 },
    { id: 25, name: 'MAVVE', file: project25 },
  ],
};

export default cards;
